import Axios from 'axios'; // 刷新token

export function BalanceParaSet(id) {
  var _this = this;

  return Axios.get('Balance/BalanceParaGet', {
    params: {
      id: id
    }
  }).then(function (res) {
    if (res.status === 200) {
      return res.data;
    } else {
      Promise.reject();
    }
  }).catch(function (err) {
    return _this.$notify.error('网络异常！');
  });
}